import { render, staticRenderFns } from "./PSWorksheet.vue?vue&type=template&id=64ce76b4&scoped=true&"
import script from "./PSWorksheet.vue?vue&type=script&lang=ts&"
export * from "./PSWorksheet.vue?vue&type=script&lang=ts&"
import style0 from "./PSWorksheet.vue?vue&type=style&index=0&id=64ce76b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce76b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
